// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-L":"L_power-ocean-collection-L___eO0R"};